/**
 * Format a date string
 * @param date the date to be formatted
 * @param options the options object https://www.w3schools.com/jsref/jsref_tolocalestring.asp
 * @returns a formatted date string
 */
export const formatDate = (
  date: any,
  options: any = {
    formatMatcher: "basic",
    year: "numeric",
    month: "long",
    day: "numeric",
  }
) => {
  if (date) {
    var dateTime = new Date(date);
    return dateTime.toLocaleString("en-NZ", options);
  } else return "";
};

/**
 * Format a date string
 * @param date the date to be formatted
 * @param options the options object https://www.w3schools.com/jsref/jsref_tolocalestring.asp
 * @returns a formatted date string
 */
export const formatDateTime = (
  date: any,
  options: any = {
    formatMatcher: "basic",
    // year: "numeric",
    // month: "long",
    // day: "numeric",
    dateStyle: "medium",
    timeStyle: "short",
  }
) => {
  if (date) {
    var dateTime = new Date(date);
    return dateTime.toLocaleString("en-NZ", options);
  } else return "";
};

/**
 * Convert 24 hour time string to 12 hour
 * @param time The 24 hour time to convert
 * @returns 12 hour time as a string
 */
export const convertTimeTo12h = (time: any) => {
  // Check correct time format and split into components
  time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [
    time,
  ];
  if (time.length > 1) {
    // If time format correct
    time = time.slice(1); // Remove full string match value
    time[5] = +time[0] < 12 ? "AM" : "PM"; // Set AM/PM
    time[0] = +time[0] % 12 || 12; // Adjust hours
  }
  return time.join(""); // return adjusted time or original string
};

export const sortByCreated = (a: any, b: any, order: any) => {
  if (order === "ASC") return sortByCreatedASC(a, b);
  else return sortByCreatedDESC(a, b);
};

export const sortByCreatedDESC = (a: any, b: any) => {
  if (a.created > b.created) return -1;
  else if (a.created < b.created) return 1;
  else return 0;
};

export const sortByCreatedASC = (a: any, b: any) => {
  if (a.created > b.created) return 1;
  else if (a.created < b.created) return -1;
  else return 0;
};

// export const sortByCreatedASC = (a: any, b: any) => {
// 	if (a.created > b.created) return 1;
// 	else if (a.created < b.created) return -1;
// 	else return 0;
// };

export const _sortPlayerByNumber = (a: any, b: any) => {
  return a.num - b.num;
};

export const _sortByName = (a: any, b: any) => {
  if (a.name > b.name) return 1;
  else if (a.name < b.name) return -1;
  else return 0;
};

export const colors = [
  "#e6194b",
  "#3cb44b",
  "#ffe119",
  "#4363d8",
  "#f58231",
  "#911eb4",
  "#46f0f0",
  "#f032e6",
  "#bcf60c",
  "#fabebe",
  "#008080",
  "#e6beff",
  "#9a6324",
  "#fffac8",
  "#800000",
  "#aaffc3",
  "#808000",
  "#ffd8b1",
  "#000075",
  "#808080",
  "#ffffff",
  "#000000",
];

export const reds = [
  "#933A16",
  "#8D021F",
  "#A50021",
  "#DC143C",
  "#C51E4A",
  "#960018",
  "#E60026",
  "#DA2C43",
  "#58111A",
  "#65000B",
  "#ED2939",
  "#893F45",
  "#CE0029",
  "#AB4E52",
  "#C08081",
  "#BF4F51",
  "#FF7F7F",
  "#F08080",
  "#674846",
  "#E23D28",
  "#E34234",
  "#A91101",
  "#7C0902",
  "#660000",
  "#E44D2E",
  "#B31B1B",
  "#8B0000",
  "#B22222",
  "#CD5C5C",
  "#E62020",
  "#800000",
  "#841617",
  "#FF2400",
  "#D44500",
  "#D05340",
  "#905D5D",
];

export const MCQanswerEnum: any = {
  0: "A",
  1: "B",
  2: "C",
  3: "D",
};

export const getDateStamp = (date: any) => {
  if (date !== "Invalid Date") {
    date.setHours(0);
    date.setMinutes(0);
    return date.toISOString();
  } else return "";
};

export const toLocalDateString = (date: any) => {
  //console.log(date);
  let res =
    date.getFullYear() +
    "-" +
    ("0" + (parseInt(date.getMonth()) + 1)).slice(-2) +
    "-" +
    ("0" + date.getDate()).slice(-2);
  //console.log(res);
  return res;
};

export const getTodayString = () => {
  var today = new Date();
  var dd = String(today.getDate()).padStart(2, "0");
  var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
  var yyyy = today.getFullYear();

  return yyyy + "-" + mm + "-" + dd;
};

export const obfuscateEmail = (email: string) => {
  if (email && email.length > 0) {
    return email.replace(/(.{4})(.*)(?=@)/, function (gp1, gp2, gp3) {
      for (let i = 0; i < gp3.length; i++) {
        gp2 += "*";
      }
      return gp2;
    });
  }
};

export const isBreakerRound = (quizConfig: any, index: number) => {
  let rounds = quizConfig.format.rounds;
  if (
    quizConfig.format.hasBreaker &&
    ((rounds === 8 && index + 1 === 5) ||
      (rounds === 6 && index + 1 === 5) ||
      (rounds === 4 && index + 1 === 4))
  )
    return true;
  return false;
};

export const showBreakerRound = (quizConfig: any, index: number) => {
  let rounds = quizConfig.format.rounds;
  if (
    quizConfig.format.hasBreaker &&
    ((rounds === 8 && index === 4) ||
      (rounds === 8 && index === 5) ||
      (rounds === 6 && index === 4) ||
      (rounds === 6 && index === 5) ||
      (rounds === 4 && index === 4))
  )
    return true;
  return false;
};

export const getRoundName = (quizConfig: any, index: number) => {
  return quizConfig.rounds[index].roundName;
};

export const getRoundQuestionCount = (quizConfig: any, index: number) => {
  return quizConfig.rounds[index].questionIds.length;
};

export const getTeamCWScore = (team: any) => {
  return team.puzzle?.filter((answer: any) => answer).length;
};

export const getTeamRoundScore = (team: any, round: number) => {
  let length = team.rounds[round - 1]?.filter((answer: any) => answer).length;

  return length || 0;
};

export const getTeamRoundAggregateScore = (team: any, progress: any) => {
  console.log(team, progress);
  let count = 0;
  team.rounds.forEach((round: any, i: any) => {
    if (round && i < progress.round) {
      round.forEach((answer: any) => {
        if (answer) count++;
      });
    }
  });

  return count;
};

export const getTeamTableScore = (team: any, progress: any) => {
  let count = 0;
  count = getTeamRoundAggregateScore(team, progress);
  if (team.puzzle) count += getTeamCWScore(team);

  return count;
};

export const getTeamBreakerDiff = (team: any) => {
  return team.breaker.proximity;
};

export const getTeamTotalAggregateScore = (team: any) => {};

export const sortByScoreAndBreaker = (a: any, b: any) => {
  if (b.score !== a.score) return b.score - a.score;

  if (a.breakerDiff === null) {
    return 1;
  }

  if (b.breakerDiff === null) {
    return -1;
  }

  return a.breakerDiff - b.breakerDiff;
};

export const uniqBy = (arr: any, predicate: any) => {
  const cb =
    typeof predicate === "function" ? predicate : (o: any) => o[predicate];

  return [
    ...arr
      .reduce((map: any, item: any) => {
        const key = item === null || item === undefined ? item : cb(item);

        map.has(key) || map.set(key, item);

        return map;
      }, new Map())
      .values(),
  ];
};

export const parseBreaker = (breaker: any) => {
  if (typeof breaker === "number") return breaker;
  return parseInt(breaker.replace(",", ""));
};
